module.exports = __webpack_public_path__ + "static/media/p6.002d26ea.png";